import {
  computed,
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";
import PuxTablePlugin from "../plugin/PuxTablePlugin";

import {
  cloneDeep,
  findIndex,
  forEach,
} from "lodash-es";

export default function FiltersSavedAPI(props, {
  filtersLocal = computed(() => []),
}) {
  const id = toRef(props, "id");
  const isSimpleTable = toRef(props, "isSimpleTable");

  const filtersSaved = ref([]);
  const loadingFiltersSaved = ref(undefined);
  const savingFiltersSaved = ref(undefined);

  const {
    isAuthenticated,
  } = PuxTablePlugin.UserAPI();

  const {
    deleteHttp,
    getHttp,
    postHttp,
    putHttp,
  } = AHttpAPI();

  const filtersSavedComputed = computed(() => {
    const FILTERS = cloneDeep(filtersSaved.value);
    forEach(FILTERS, filter => {
      filter.label = filter.nfi_kbez;
      filter.data = filter.nfi_conf;
    });

    return FILTERS;
  });

  const loadSavedFilters = () => {
    if (!isAuthenticated.value ||
      !filtersLocal.value.length ||
      isSimpleTable.value) {
      return;
    }
    loadingFiltersSaved.value = true;
    getHttp({
      url: "nutzerfilter/",
      urlParams: {
        nfi_kennung: id.value,
      },
    }).then(
      response => {
        filtersSaved.value = response;
        loadingFiltersSaved.value = false;
      }
    );
  };

  const updateFiltersSaved = ({ action, label, model }) => {
    savingFiltersSaved.value = true;
    const data = {
      nfi_kbez: label,
      nfi_kennung: id.value,
      nfi_conf: model,
    };
    if (action === "create") {
      return postHttp({
        url: "nutzerfilter/",
        data,
      }).then(
        response => {
          filtersSaved.value.push(response);
        }
      ).finally(
        () => {
          savingFiltersSaved.value = false;
        }
      );
    } else if (action === "update") {
      const CURRENT_FILTER_INDEX = findIndex(filtersSaved.value, ["nfi_kbez", label]);
      if (CURRENT_FILTER_INDEX === -1) {
        return;
      }
      return putHttp({
        url: `nutzerfilter/${ filtersSaved.value[CURRENT_FILTER_INDEX].pk }/`,
        data,
      }).then(
        response => {
          filtersSaved.value.splice(CURRENT_FILTER_INDEX, 1, response);
        }
      ).finally(
        () => {
          savingFiltersSaved.value = false;
        }
      );
    } else if (action === "delete") {
      const CURRENT_FILTER_INDEX = findIndex(filtersSaved.value, ["nfi_kbez", label]);
      if (CURRENT_FILTER_INDEX === -1) {
        return;
      }
      return deleteHttp({
        url: `nutzerfilter/${ filtersSaved.value[CURRENT_FILTER_INDEX].pk }/`,
      }).then(
        () => {
          filtersSaved.value.splice(CURRENT_FILTER_INDEX, 1);
        }
      );
    }
  };

  return {
    filtersSavedComputed,
    loadSavedFilters,
    updateFiltersSaved,
  };
}
